import { render, staticRenderFns } from "./AddNotesModalNew.vue?vue&type=template&id=6cd498d7&scoped=true"
import script from "./AddNotesModalNew.vue?vue&type=script&lang=ts"
export * from "./AddNotesModalNew.vue?vue&type=script&lang=ts"
import style0 from "./AddNotesModalNew.vue?vue&type=style&index=0&id=6cd498d7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd498d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cd498d7')) {
      api.createRecord('6cd498d7', component.options)
    } else {
      api.reload('6cd498d7', component.options)
    }
    module.hot.accept("./AddNotesModalNew.vue?vue&type=template&id=6cd498d7&scoped=true", function () {
      api.rerender('6cd498d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AddNotesModalNew.vue"
export default component.exports